import AboutMe from "../components/AboutMe"
import Footer from "../components/Footer"
import Header from "../components/Header";

function AboutPage () {
  return (
    <>
      <Header />
      <AboutMe />
      <Footer />
    </>
  )
}

export default AboutPage;
